var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundCIrcle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1800,
    height: 1800,
    viewBox: "0 0 1800 1800",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse",
    fill: "#f46e51",
    fillOpacity: 0.297693,
    fillRule: "evenodd",
    stroke: "none",
    d: "M 1768 900 C 1768 420.616821 1379.383179 32 900 32 C 420.616852 32 32 420.616821 32 900 C 32 1379.383179 420.616852 1768 900 1768 C 1379.383179 1768 1768 1379.383179 1768 900 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-copy",
    fill: "#f46e51",
    fillOpacity: 0.396366,
    fillRule: "evenodd",
    stroke: "none",
    d: "M 1600 900 C 1600 513.400635 1286.599365 200 900 200 C 513.400635 200 200 513.400635 200 900 C 200 1286.599365 513.400635 1600 900 1600 C 1286.599365 1600 1600 1286.599365 1600 900 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-copy-2",
    fill: "#f46e51",
    fillOpacity: 0.497965,
    fillRule: "evenodd",
    stroke: "none",
    d: "M 1410 900 C 1410 618.334717 1181.665283 390 900 390 C 618.334778 390 390 618.334717 390 900 C 390 1181.665283 618.334778 1410 900 1410 C 1181.665283 1410 1410 1181.665283 1410 900 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-copy-3",
    fill: "#f46e51",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 1253 900 C 1253 705.043457 1094.956543 547 900 547 C 705.043518 547 547 705.043457 547 900 C 547 1094.956543 705.043518 1253 900 1253 C 1094.956543 1253 1253 1094.956543 1253 900 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundCIrcle);
export default __webpack_public_path__ + "static/media/backgroundCIrcle.55b39b8ead08ebc0ae046853c0d9e1ab.svg";
export { ForwardRef as ReactComponent };